module.exports = __webpack_public_path__ + "img/20190812162943289.72e06192.png";